import styled from "styled-components";
import colors from "../../../../../../config/colors";
import { Scrollable, panelSpacing } from "../../../../../../common/styles";
import { SectionContent } from "../../../../../../common/Accordian/styles";
import { InvitesContainer } from "../Invites/styles";

export const ActiveParticipantsContainer = styled.div`
  display: flex;
  min-width: 1150px;
  @media (max-width: 991px) {
    flex-direction: column;
    gap: 20px;
    min-width: fit-content;
  }
`;

export const ActiveParticipantsWrapper = styled.div`
  overflow-x: auto;
`;
export const ParticipantsActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const MentorHeading = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 6px 12px;
  border-radius: 10px 10px 0px 0px;
  border: 1px solid #ededf4;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const MentorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 10px);
  @media (max-width: 767px) {
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }
`;
export const Info = styled.div`
  display: flex;
  align-items: center;
  width: ${(props) => (props.width ? props.width : "auto")};
  aspect-ratio: ${(props) => (props.squareSize ? "1/1" : "auto")};
  min-width: ${(props) => (props.nonWidth ? "" : "185px")};
  // @media (max-width: 767px) {
  //   min-width: fit-content;
  // }
`;
export const Image = styled.img`
  height: 35px;
  width: 35px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 10px;
`;
export const Name = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-weight: 400;
  text-transform: capitalize;
`;
export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  margin: 0 10px 0 auto;
  @media (max-width: 767px) {
    order: 1;
    margin: 0;
    width: calc(100% - 90px);
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Meta = styled.div`
  font-family: "Nunito Sans";
  font-size: 14px;
  font-weight: 400;
  color: ${colors.primary};
  min-width: max-content;
`;
export const MenteeHeader = styled(MentorHeader)`
  background-color: ${colors.background};
  padding: ${panelSpacing / 4}px;
  box-sizing: border-box;
  margin-bottom: ${panelSpacing / 2}px;
  border-radius: ${panelSpacing / 2}px;
  width: 100%;
  :last-of-type {
    margin-bottom: 0px;
  }
  .reassignBtn {
    @media (max-width: 991px) {
      order: 2;
    }
  }
`;

export const InfoTitle = styled.div`
  color: #757575;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-weight: 300;
`;

export const UnassignedList = styled.div`
  padding: 10px 6px 16px 8px;
  border-radius: 0 0 10px 10px;
  background: #f2f2f2;
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
export const ParticipantsContainer = styled(InvitesContainer)`
  width: 50%;
  min-width: 800px;
  padding: 20px 0 20px 20px;
  height: 100%;
  border-right: 1px solid #efefef;
  overflow: ${(props) => (props.isTeam ? "hidden scroll" : "hidden")};
  ${(props) =>
    props.scrollStyle &&
    `
    height: calc(100vh - 270px - 80px);
        overflow-y: auto;
    padding-right: 19px;
     
  `}

  @media (max-width: 1600px) {
    min-width: 700px;
  }
  @media (max-width: 1366px) {
    min-width: 620px;
  }
  @media (max-width: 991px) {
    height: fit-content;
    width: 100%;
    min-width: 100%;
    ${(props) =>
      props.scrollStyle &&
      `
    height: fit-content;
       overflow-y: clip;
    padding-right: 15px;
     
  `}
  }
`;

export const ParticipantsContainerInner = styled.div`
  // height: calc(100vh - 220px - ${panelSpacing * 4}px);
  // overflow-y: scroll;
  -ms-overflow-style: none;
`;

export const UnassignedContainer = styled(InvitesContainer)`
  width: 50%;
  padding: ${panelSpacing}px ${panelSpacing / 4}px;
  ${(props) =>
    props.scrollStyle &&
    `
    height: calc(100vh - 270px - 80px);
        overflow-y: auto;
    padding-right: 19px;
  `}
  @media (max-width: 991px) {
    height: fit-content;
    width: 100%;
    padding: 20px;
    ${(props) =>
      props.scrollStyle &&
      `
    height: fit-content;
        overflow-y: clip;
    padding-right: 15px;
     
  `}
  }
`;

export const ViewChatIconContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin: 0 4px 0 auto;
  width: ${(props) => props.isDeletedAt && "132px"} @media (max-width: 768px) {
    order: 0;
    ${(props) =>
      props.isSet
        ? `    
        position: absolute;
    top: 0;
    right: -34px;`
        : " "};
    margin: 0 0 0 auto;
  }
`;

export const DropDownToggle = styled.div`
  display: flex;
  width: 31.218px;
  height: 31.218px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 9.756px;
  border-radius: 2.927px;
  background: rgba(76, 75, 154, 0.1);
  cursor: pointer;
`;

export const UnAssignButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
  div {
    margin-right: 10px;
  }
  &:last-child {
    margin: 0;
  }
`;

export const DropIcon = styled.div`
  cursor: pointer;
`;
export const DropdownItems = styled.div`
  position: absolute;
  top: 25px;
  left: -135px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
  z-index: 2;
`;

export const DropdownButton = styled.button`
  width: 100%;
  padding: 10px;
  border: none;
  border-bottom: 1px solid #ddd;
  background-color: white;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  svg {
    margin-right: 8px;
  }
`;
